import React, { useState } from "react";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import DetailWrapper from "../../../components/detailWrapper";
import { Button } from "semantic-ui-react";
import OriginInputCustom from "../../../components/InputComponents/originInputCustom";
import { useNavigate } from "react-router";
import { HiChevronLeft } from "react-icons/hi";
import {
  transactionExpress,
  transactionExpressForInput,
} from "../../../regex_constanst";
import { useDispatch, useSelector } from "react-redux";
import { notice } from "../../../redux/action/action";
import { useTranslation } from "react-i18next";
import { resetWithdrawPassword } from "../../../api/postApi";
import PleaseSetUserIDCard from "../../Withdraw/pleaseSetUserIDCard";

const ResetWithdrawPassword = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`settings.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const memberData = useSelector((state) => state.isMemberInfo);

  const [data, setData] = useState({
    old_withdraw_password: "",
    new_withdraw_password: "",
    new_withdraw_password_again: "",
  }); //這裡的old_password取名可以自己取，後面預設值""意思是一開始進來的時候是空的

  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      old_withdraw_password,
      new_withdraw_password,
      new_withdraw_password_again,
    } = data;
    if (transactionExpress.test(new_withdraw_password)) {
      if (new_withdraw_password === new_withdraw_password_again) {
        resetWithdrawPassword({
          old_pwd: old_withdraw_password, //這裡設定old_pwd是因為後端要求 後面的old_withdraw_password是因為這裡的data是從useState來的
          new_pwd: new_withdraw_password,
        })
          .then((data) => {
            dispatch(notice(i18n_formHint("setSuccess"), "success"));
            navigate("../reset-withdraw-password-success");
          })
          .catch((err) => {})
          .finally(() => {});
      } else {
        dispatch(notice(i18n_formHint("twoPassword"), "error"));
      }
    } else {
      dispatch(
        notice(i18n_formHint("passwordFormatError", { number: 4 }), "error")
      );
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const formData = [
    {
      name: "old_withdraw_password",
      label: i18n("form.old_withdraw_password"),
      type: "password",
      pattern: transactionExpressForInput,
      onChange: (e) => {
        handleChange(e);
      },
    },
    {
      name: "new_withdraw_password",
      label: "New Withdraw Password",
      type: "password",
      placeholder: i18n_formHint("includeFourNumber"),
      pattern: transactionExpressForInput,
      onChange: (e) => {
        handleChange(e);
      },
    },
    {
      name: "new_withdraw_password_again",
      label: "New Withdraw Password Again",
      type: "password",
      placeholder: i18n_formHint("includeFourNumber"),
      pattern: transactionExpressForInput,
      onChange: (e) => {
        handleChange(e);
      },
    },
  ];
  return memberData.isBindAccount == 0 ? (
    <PleaseSetUserIDCard />
  ) : (
    <DetailWrapper
      closeAnimate
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1] bg-gradient-to-br`}
    >
      <CloseDetailPage
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate("..")}
          />
        }
        title={i18n("resetWithdrawPassword")}
      />
      <article className="flex flex-col gap-[10px] p-[15px]">
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          {formData.map((item, index) => {
            return (
              <div>
                <span className="text-sm text-transaction-text dark:text-base-light-white font-medium">
                  {i18n(`form.${item.name}`)}
                </span>
                <OriginInputCustom
                  {...item}
                  title={item.placeholder}
                  name={item.name}
                  type={item.type}
                />
              </div>
            );
          })}
          <Button
            type="submit"
            disabled={!Object.keys(data).every((item) => data?.[item] !== "")}
            content={i18n_common("SAVE")}
            size="xl"
            className="!bg-main-color !text-white w-full !py-[17px] !mt-[20px]"
          ></Button>
        </form>
      </article>
    </DetailWrapper>
  );
};

export default ResetWithdrawPassword;
